var map = {
	"./akeneo.png": 7274,
	"./algolia.png": 6500,
	"./bigcommerce.png": 2793,
	"./gorgias.png": 4754,
	"./klaviyo.png": 9254,
	"./matter.png": 9715,
	"./starshipit.png": 9510,
	"./yotpo.png": 5213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2302;